module.exports = __webpack_public_path__ + "images/init-stars-projects-12fdd603f0280d488b845a07d02f8045.png";